// extracted by mini-css-extract-plugin
module.exports = {"icon":"_1tyXzVrAv8","left":"XdpsSv6dql","right":"_2_BRxMp4AF"};
    if(module.hot) {
      // 1614934692187
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  